import { Pipe, PipeTransform } from '@angular/core';
import { MigrationSource } from '../migration-source.enum';

const { NETFIRM, ULTRATAX, FILECABINET, PRACTICECS, ACCOUNTINGCS } = MigrationSource;

@Pipe({
	name: 'applicationName'
})
export class ApplicationNamePipe implements PipeTransform {

	transform(migrationSource: MigrationSource): string {
		let uiApplicationName: string = migrationSource;
		switch (migrationSource) {
		case NETFIRM:
			uiApplicationName = 'NetClient CS';
			break;
		case PRACTICECS:
			uiApplicationName = 'Practice CS';
			break;
		case ULTRATAX:
			uiApplicationName = 'UltraTax CS';
			break;
		case ACCOUNTINGCS:
			uiApplicationName = 'Accounting CS';
			break;
		case FILECABINET:
			uiApplicationName = 'FileCabinet';
			break;
		default: console.warn(`Unexpected migration source: ${migrationSource} to get its UI name.`);
		}

		return uiApplicationName;
	}

}
